import React from "react";
import { useTranslation } from "react-i18next";

const HintsStep = () => {
  const { t } = useTranslation();

  return (
    <div className="p-5 text-center">
      <div className="p-5 rounded-lg mb-5 text-left">
        <p className="text-foreground leading-relaxed">
          {t(
            "book_location.hints.content",
            "After your online purchase, reserve a locker in the app. No initial payment needed—just your name, email, and phone number. We'll send you the locker location and a PIN code via email. Update your delivery address in the tracking portal with this info. The delivery agent will use the PIN to drop off your parcel securely. You'll get a notification once it's delivered—pick it up at your earliest convenience! You can also (optionally) add a delivery date and parcel size to help us pick the right locker."
          )}
        </p>
      </div>
    </div>
  );
};

export default HintsStep;
